import { PRODUCT_LINE_CODE } from '../../../shared/constants/product-lines-codes';
import { cementBag } from './cement-bag';

export const deConfig = {
  [PRODUCT_LINE_CODE.BAG_CEMENT]: cementBag,
};
